import PayrollIntegrationsService from '@/services/payroll-integrations.service';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

type PlanBlockersResult = {
  blockReasons: string;
  isBlocked: boolean;
};

function getUniqueBlockReasons(reasons: string[]): string {
  return Array.from(
    new Set(
      reasons
        .flatMap(reason => reason.split(';').map(r => r.trim()))
        .filter(Boolean)
    )
  ).join('; ');
}

export default function usePlanBlockers(
  sponsorPlanId: number
): UseQueryResult<PlanBlockersResult> {
  const blockStatus = useQuery(
    ['PayrollIntegrationsService.getPayrollIntegrationBlockers', sponsorPlanId],
    () =>
      PayrollIntegrationsService.getPayrollIntegrationBlockers(sponsorPlanId),
    {
      select: data => {
        const rawReasons = data?.map(p => p.reason) ?? [];
        const blockReasons = getUniqueBlockReasons(rawReasons);
        const isBlocked = !!data?.length;
        return { blockReasons, isBlocked };
      }
    }
  );

  return blockStatus;
}
